import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  fill(event) {
    const prompt = event.target.dataset.prompt || event.target.closest("[data-prompt]")?.dataset.prompt
    if (prompt && this.hasInputTarget) {
      this.inputTarget.value = prompt
      this.inputTarget.focus()
    }
  }
}
